
                    (function(){
                      const root = document.getElementById('svastiMobileSolariMatrix');
                      if(!root) return;
                      const ROWS = 7;
                      const FONT = {
                        'A':["00110","01001","10001","11111","10001","10001","10001"],
                        'B':["11110","10001","10001","11110","10001","10001","11110"],
                        'C':["01111","10000","10000","10000","10000","10000","01111"],
                        'E':["11111","10000","10000","11110","10000","10000","11111"],
                        'G':["01111","10000","10000","10011","10001","10001","01111"],
                        'K':["10001","10010","10100","11000","10100","10010","10001"],
                        'N':["10001","11001","10101","10011","10001","10001","10001"],
                        'O':["01110","10001","10001","10001","10001","10001","01110"],
                        'P':["11110","10001","10001","11110","10000","10000","10000"],
                        'R':["11110","10001","10001","11110","10100","10010","10001"],
                        'U':["10001","10001","10001","10001","10001","10001","01110"],
                        'W':["10001","10001","10001","10101","10101","11011","10001"],
                        'Y':["10001","10001","01010","00100","00100","00100","00100"],
                        ' ':["00000","00000","00000","00000","00000","00000","00000"],
                        '-':["00000","00000","00000","11111","00000","00000","00000"],
                        // Art
                        '>': [ // Top-Down Swept Wing Airliner
                          "00000110000000",
                          "01100111000000",
                          "11100011110000",
                          "11111111111110",
                          "11100011110000",
                          "01100111000000",
                          "00000110000000"
                        ],
                        '~': [ // Rope
                           "00000",
                           "00000",
                           "00000",
                           "11111",
                           "00000",
                           "00000",
                           "00000"
                        ],
                        '*': [ // Heart
                           "00000000",
                           "00110110",
                           "01111111",
                           "01111111",
                           "00111110",
                           "00011100",
                           "00001000"
                        ]
                      };
                      const SEQ = ['CARE','PACKAGE','BUY','NOW'];
                      const ANIM_SEQ = "*~~~~~>"; // Scroll string
                      const RAND = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
                      function calcCols(){
                        const w = Math.min(window.innerWidth, document.documentElement.clientWidth || window.innerWidth);
                        return 54; 
                      }
                      function buildTiles(cols){
                        root.style.setProperty('--m-cols', cols);
                        root.innerHTML = '';
                        for(let i=0; i<cols*ROWS; i++){
                          const d = document.createElement('div');
                          d.className = 'm-tile';
                          const s = document.createElement('span');
                          s.className = 'm-ch';
                          s.textContent = '·';
                          d.appendChild(s);
                          root.appendChild(d);
                        }
                      }
                      function makeFullMask(text){
                         const r = Array.from({length: ROWS}, () => []);
                         for(let char of text){
                            const glyph = FONT[char] || FONT[' '];
                            for(let i=0; i<ROWS; i++){
                               for(let bit of glyph[i]) r[i].push(bit === '1');
                               // Gap Logic: 1px gap usually
                               // No gap inside art parts
                               if(char !== '>' && char !== '~' && char !== '*' && char !== ' ') {
                                  r[i].push(false); 
                               }
                            }
                         }
                         return r;
                      }
                      function paint(mask, cols, offset, mode, p){
                        const tiles = root.children;
                        const maskLen = mask[0].length;
                        let startX = 0;
                        if(mode !== 'scroll') startX = Math.floor((cols - maskLen) / 2);
                        for(let r=0; r<ROWS; r++){
                          for(let c=0; c<cols; c++){
                            const t = tiles[r*cols + c];
                            if(!t) continue;
                            
                            let isPixel = false;
                            if(mode === 'scroll') {
                               const idx = c + offset;
                               if(idx >= 0 && idx < maskLen) isPixel = !!mask[r][idx];
                            } else {
                               const idx = c - startX;
                               if(idx >= 0 && idx < maskLen) isPixel = !!mask[r][idx];
                            }
                            
                            if(mode === 'scroll') {
                               if(isPixel) { t.classList.add('pixel'); t.firstChild.textContent = ''; }
                               else { t.classList.remove('pixel'); t.firstChild.textContent = '·'; }
                            } else {
                               if(Math.random() < 0.20) t.classList.add('flip');
                               else t.classList.remove('flip');
                               if(mode === 'hold'){
                                 if(isPixel) { t.classList.add('pixel'); t.firstChild.textContent = ''; }
                                 else { t.classList.remove('pixel'); t.firstChild.textContent = '·'; }
                               } else if (mode === 'in'){
                                 if(isPixel && Math.random() < p) { 
                                   t.classList.add('pixel'); t.firstChild.textContent = ''; 
                                 } else { 
                                   t.classList.remove('pixel'); t.firstChild.textContent = RAND[Math.floor(Math.random()*RAND.length)]; 
                                 }
                               }
                            }
                          }
                        }
                      }
                      async function run(){
                        let cols = calcCols();
                        buildTiles(cols);
                        while(true){
                          // 1. Show Words
for(let word of SEQ){
  const mask = makeFullMask(word);
  // Flap In
  for(let i=0; i<5; i++){ paint(mask, cols, 0, 'in', i/5); await new Promise(r => setTimeout(r, 40)); }
  // Hold
  paint(mask, cols, 0, 'hold', 1);
  await new Promise(r => setTimeout(r, 900));
}

// 2. Plane Animation - 0.5s extra wait after last word (compared to word switch time)
await new Promise(r => setTimeout(r, 500));

const animMask = makeFullMask(ANIM_SEQ);
const animWidth = animMask[0].length;

// Scroll LEFT to RIGHT (plane enters immediately from left)
for(let off = animWidth; off >= -cols; off--){
    paint(animMask, cols, off, 'scroll', 1);
    await new Promise(r => setTimeout(r, 35));
}

          // Small pause before restarting the loop
          await new Promise(r => setTimeout(r, 300));
        }
      }
                      
      const io = new IntersectionObserver(e => { if(e[0].isIntersecting){ run(); io.disconnect(); } }, { threshold: 0.1 });
      io.observe(root);
    })();
                  